import {Box, Text} from 'platform/foundation';
import styled from 'styled-components';

import {suffixTestId, TestIdProps} from 'shared/web';

import {handleDropdownStickyRegionKeyDown} from '../utils/handleDropdownStickyRegionKeyDown';

interface SavedFiltersDropdownFooterProps extends TestIdProps {
  label: string;
  isDisabled: boolean;
  onClick: () => void;
}

export function SavedFiltersDropdownFooter(props: SavedFiltersDropdownFooterProps) {
  return (
    <Box
      flexShrink={0}
      paddingTop={2}
      borderTop="1px solid"
      borderColor="general.separator"
      backgroundColor="general.white"
    >
      <div onKeyDown={handleDropdownStickyRegionKeyDown}>
        <CreateNewButton
          type="button"
          onClick={props.onClick}
          disabled={props.isDisabled}
          data-testid={suffixTestId('createNew', props)}
        >
          <Text size="small" alternative>
            {props.label}
          </Text>
        </CreateNewButton>
      </div>
    </Box>
  );
}

const CreateNewButton = styled.button`
  display: block;
  width: 100%;
  padding: ${({theme}) => theme.getSize(2)};
  border: none;
  border-radius: ${({theme}) => theme.radii.small};
  background-color: ${({theme}) => theme.colors.palettes.white[10][100]};
  color: ${({theme}) => theme.colors.text.primary};
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: ${({theme}) => theme.colors.palettes.blue[10][100]};
  }

  &:focus-visible {
    background-color: ${({theme}) => theme.colors.palettes.blue[10][100]};
    outline: none;
    box-shadow: ${({theme}) => theme.shadows.active};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
